import { Tag, TagCloseButton, TagLabel } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

interface HiddenElementsButtonProps {
  numHiddenElements: number;
  onClearHidden: () => void;
}

export default function HiddenElementsButton({
  numHiddenElements,
  onClearHidden,
}: HiddenElementsButtonProps) {
  const { t } = useTranslation('project');

  if (numHiddenElements === 0) {
    return null;
  }

  return (
    <Tag size="sm" borderRadius="full" variant="toggle">
      <TagLabel>
        {t('viewer-interactions.hidden-elements', { numHiddenElements })}
      </TagLabel>
      <TagCloseButton
        onClick={onClearHidden}
        aria-label={t('viewer-interactions.clear-hidden')}
      />
    </Tag>
  );
}
